import { Component } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lib-home',
  standalone: true,
  imports: [CommonModule, MatCard, MatCardContent, RouterLink, NgOptimizedImage],
  templateUrl: './error404.component.html',
})
export class Error404Component {}
